// src/i18n/es/reservations.ts
// «Reservas» (mockup 03) — drill-down list under Recepción / Dirección, and
// the reservation detail (mockup 04, §6.7 of the proposal).
export const reservations = {
  name: 'Reservas',

  filters: {
    button: 'Filtros',
    hotel: 'Hotel',
    axis: 'Eje de fecha',
    axisArrival: 'Llegada',
    axisActivity: 'Actividad',
    from: 'Desde',
    to: 'Hasta',
    state: 'Estado',
    channelUsed: 'Canal',
    preCheckIn: 'Pre-check-in',
    preCheckInDone: 'Hecho',
    preCheckInPartial: 'A medias',
    preCheckInNone: 'Sin empezar',
    payment: 'Pago',
    paymentPaid: 'Pagado',
    paymentFailed: 'Fallido',
    paymentNone: 'Sin pago',
    key: 'Llave',
    keyCard: 'Tarjeta',
    keyDigital: 'Llave digital',
    keyNone: 'Sin llave',
    kioskLeftMidway: 'Se quedó a medias en el kiosco',
    needsHelp: 'Necesita ayuda',
    isWalkIn: 'Walk-in',
    origin: 'Origen',
    search: 'Buscar por huésped o número de reserva',
    apply: 'Aplicar',
    clear: 'Limpiar filtros',
  },

  activeFilters: {
    axis: 'Eje: %{value}',
    from: 'Desde %{value}',
    to: 'Hasta %{value}',
    state: 'Estado: %{value}',
    channelUsed: 'Canal: %{value}',
    preCheckIn: 'Pre-check-in: %{value}',
    payment: 'Pago: %{value}',
    key: 'Llave: %{value}',
    kioskLeftMidway: 'Se quedó a medias',
    needsHelp: 'Necesita ayuda',
    isWalkIn: 'Walk-in',
    origin: 'Origen: %{value}',
    search: 'Búsqueda: %{value}',
  },

  columns: {
    arrival: 'Llegada',
    departure: 'Salida',
    guest: 'Huésped',
    room: 'Hab.',
    hotel: 'Hotel',
    preCheckIn: 'Pre-check-in',
    checkIn: 'Check-in',
    key: 'Llave',
    charged: 'Cobrado',
    state: 'Estado',
  },

  checkIn: {
    reception: 'Recepción',
    none: '—',
  },

  summary: {
    count: '%{count} reserva |||| %{count} reservas',
    checkedIn: 'Check-in %{count}',
    preCheckInDone: 'Pre-check-in hecho %{count}',
    charged: 'Cobrado %{amount}',
  },

  emptyState: {
    title: 'No hay reservas con estos filtros',
    description: 'Pruebe a ampliar el rango de fechas o a quitar algún filtro.',
  },

  detail: {
    title: 'Detalle de reserva',
    reservationNumber: 'Reserva %{number}',
    adults: '%{count} adulto |||| %{count} adultos',
    children: '%{count} niño |||| %{count} niños',
    origin: 'Origen: %{origin}',
    arrivalDeparture: 'Llegada %{arrival} · Salida %{departure}',
    room: 'Habitación %{room}',
    walkIn: 'Walk-in',

    facts: {
      preCheckIn: 'Pre-check-in',
      identification: 'Identificación',
      payment: 'Pago',
      checkIn: 'Check-in',
      key: 'Llave',
      stay: 'Estancia',
      nights: '%{count} noche |||| %{count} noches',
      night: '1 noche',
    },

    timeline: {
      title: 'El recorrido del huésped',
      empty: 'Todavía no hay actividad registrada para esta reserva.',
      attemptsPreCheckIn: '%{smart_count} intento de pre-check-in |||| %{smart_count} intentos de pre-check-in',
      attemptsKiosk: '%{smart_count} intento en el kiosco |||| %{smart_count} intentos en el kiosco',
      technicalLink: 'Ver detalle técnico',
      kinds: {
        linkOpened: 'Abrió el enlace de pre-check-in',
        started: 'Empezó el pre-check-in',
        stopped: 'Se detuvo en %{section}',
        resumed: 'Volvió a continuar',
        preCheckInDone: 'Pre-check-in hecho · %{identified} de %{total} identificados',
        checkInStarted: 'Empezó el check-in',
        checkInDone: 'Check-in hecho · %{duration}',
        paymentDone: 'Cobrados %{amount} con %{method}',
        paymentFailed: 'No pudo continuar en Pago',
        keyDelivered: 'Llave entregada · %{keyType} · habitación %{room}',
        keyFailed: 'No se pudo entregar la llave',
      },
    },
  },

  export: {
    page: 'reservations',
    reservationNumber: 'Número de reserva',
    room: 'Habitación',
    identification: 'Identificados',
    payment: 'Pago',
    preCheckInDoneAt: 'Pre-check-in hecho el',
    currency: 'Moneda',
  },

  help: {
    title: 'Reservas',
    description: 'El listado completo de reservas, con filtros por fecha, canal, estado de pre-check-in, pago y llave.',
    features: {
      urlFilters: 'Los filtros se guardan en la dirección: puede compartir una vista filtrada.',
      rowClick: 'Cada fila abre la ficha completa de la reserva.',
      summary: 'El resumen se calcula sobre el conjunto filtrado, no solo la página visible.',
      charged:
        '«Cobrado» sigue la regla de Cobros: cargos firmes menos devoluciones de las reservas filtradas, en todos los canales, sin preautorizaciones y una cifra por moneda. Muestra «—» cuando alguna reserva cobrada no tiene el detalle de sus transacciones. La columna «Cobrado» de cada fila aplica la misma regla a esa reserva; «—» si no se cobró nada o falta el detalle.',
    },
    tips: {
      search: 'Use la búsqueda para encontrar una reserva por huésped o número.',
      export: 'Exporte la vista filtrada a CSV con el botón «Exportar».',
    },
  },
};

export default reservations;
